import { render, staticRenderFns } from "./anulirsiswa.vue?vue&type=template&id=694027da&"
import script from "./anulirsiswa.vue?vue&type=script&lang=js&"
export * from "./anulirsiswa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports